import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Ticket = ({ className }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        xmlns="http://www.w3.org/2000/svg"
        width="80.96"
        height="29.89"
        viewBox="0 0 80.96 29.89"
    >
        <path
            d="M77,14.94c0-4,1.64-7.29,3.65-7.29V.36H.36V29.52H80.6V22.23C78.59,22.23,77,19,77,14.94Z"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="0.73"
        />
        <line
            x1="66.02"
            y1="0.36"
            x2="66.02"
            y2="1.82"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="0.73"
        />
        <line
            x1="66.02"
            y1="3.2"
            x2="66.02"
            y2="27.37"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="0.73"
            strokeDasharray="2.76 1.38"
        />
        <line
            x1="66.02"
            y1="28.06"
            x2="66.02"
            y2="29.52"
            fill="none"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="0.73"
        />
    </svg>
);

Ticket.propTypes = propTypes;
Ticket.defaultProps = defaultProps;

export default Ticket;
